import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '@app/app/shared/services/authentication.service';
import {FormControl, FormGroup} from '@angular/forms';
import {AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MatPaginator, MatSort, MatTableDataSource} from '@angular/material';
import {merge} from 'rxjs/observable/merge';
import {of as observableOf} from 'rxjs/observable/of';
import {catchError} from 'rxjs/operators/catchError';
import {map} from 'rxjs/operators/map';
import {startWith} from 'rxjs/operators/startWith';
import {switchMap} from 'rxjs/operators/switchMap';
import {MatDialog} from '@angular/material';
import {EmployeesDialogComponent} from '@app/app/employees/employees.dialog.component';
import {Subscription} from 'rxjs/Subscription';

@Component({
  moduleId: module.id,
  selector: 'employees',
  styleUrls: ['employees.css'],
  templateUrl: 'employees.component.html'
})

export class EmployeesComponent implements OnInit, OnDestroy {
  displayedColumns = ['id', 'first_name', 'last_name', 'email', 'phone', 'created', 'actions'];
  dataSource = new MatTableDataSource();
  resultsLength = 0;
  isLoadingResults = true;

  filterForm = new FormGroup({
    query: new FormControl(),
    active: new FormControl(),
  });

  included = [];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  filter = new Filter();
  sub1: Subscription;
  sub2: Subscription;

  public isAdmin = false;

  ngOnDestroy() {
    if (this.sub1) {
      this.sub1.unsubscribe();
    }

    if (this.sub2) {
      this.sub2.unsubscribe();
    }
  }

  constructor(private http: HttpClient, private route: ActivatedRoute, public dialog: MatDialog, private auth: AuthenticationService) {
    this.isAdmin = ('admin' === this.auth.userRole());
  }

  applyFilter(filterValue: string) {
    this.filter.change(filterValue);
  }

  private getPrefix() {
    if (this.auth.userRole() === 'admin') {
      return 'admins';
    } else if (this.auth.userRole() === 'client') {
      return 'clients';
    }

    return '';
  }

  private prepareUrl() {
    let sortField = '';

    if ((this.sort.direction === 'asc' || this.sort.direction === 'desc') && this.sort.active) {
      if (this.sort.direction === 'desc') {
        sortField = '-' + this.sort.active;
      } else if (this.sort.direction === 'asc') {
        sortField = this.sort.active;
      }
    }

    const page = this.paginator.pageIndex + 1 || 1;
    const query = this.filter.filterValue || '';
    const active = this.filter.activeValue || '';

    return `/${this.getPrefix()}/${this.auth.userId()}/employees?filter[query]=${query}&page=${page}&sort=${sortField}&filter[active]=${active}`;
  }

  clear() {
    this.filter.reset();
    this.filterForm.patchValue({
      query: null,
      active: null
    });
  }

  toggleActive(value) {
    this.filter.changeA(value);
  }

  ngOnInit() {
    // If the user changes the sort order, reset back to the first page.
    this.sub1 = this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    this.sub2 = merge(this.filter.filterApplied, this.sort.sortChange, this.paginator.page).pipe(
      startWith({}),
      switchMap(() => {
        this.isLoadingResults = true;
        return this.http.get<any>(this.prepareUrl());
      }),
      map(data => {
        this.isLoadingResults = false;
        this.resultsLength = data.meta.pagination.total;

        return {data: data.data, included: data.included};
      }),
      catchError(() => {
        this.isLoadingResults = false;
        return observableOf([]);
      })
    ).subscribe((data: any) => {
      this.dataSource.data = data.data;
      this.included = data.included;
    });

    this.dataSource.sort = this.sort;
  }

  openDialog(user = null): void {
    const dialogRef = this.dialog.open(EmployeesDialogComponent, {
      width: '400px',
      data: {user: user, included: this.included}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (typeof result !== 'undefined' && result === 'Confirm') {
        this.reloadData();
      }
    });
  }

  deleteUserItem(user) {
    if (confirm(`Are you sure want to delete ${user.attributes.first_name} ${user.attributes.last_name}?`)) {
      this.http.delete(`/${this.getPrefix()}/${this.auth.userId()}/employees/${user.id}`).subscribe(res => {
        this.reloadData();
      });
    }
  }

  reloadData() {
    this.isLoadingResults = true;

    return this.http.get<any>(this.prepareUrl()).subscribe(data => {
      this.isLoadingResults = false;
      this.resultsLength = data.meta.pagination.total;
      this.dataSource.data = data.data;
    });
  }
}

export class Filter {
  filterApplied = new EventEmitter();
  filterValue = '';
  activeValue = '';

  reset() {
    this.filterValue = '';
    this.activeValue = '';
    this.filterApplied.emit();
  }

  change(val: string) {
    this.filterValue = val;
    this.filterApplied.emit();
  }

  changeA(val: string) {
    this.activeValue = val;
    this.filterApplied.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/employees/employees.component.ts